import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fieldState", "fieldApi"];
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './customSelect.module.css';
import { asField } from 'informed';
import SelectInput from './SelectInput';
import List from './List';
import { useOutsideAlerter } from '../../hooks/useOutsideAlerter';
var CustomSelect = asField(function (_ref) {
  var fieldState = _ref.fieldState,
      fieldApi = _ref.fieldApi,
      props = _objectWithoutProperties(_ref, _excluded);

  var options = props.options,
      propClasses = props.classes,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      isTwoDimensional = props.isTwoDimensional,
      isPageSize = props.isPageSize,
      field = props.field,
      id = props.id,
      _props$defaultMessage = props.defaultMessage,
      defaultMessage = _props$defaultMessage === void 0 ? '' : _props$defaultMessage,
      startValue = props.startValue,
      _props$isSearchable = props.isSearchable,
      isSearchable = _props$isSearchable === void 0 ? true : _props$isSearchable,
      _props$label = props.label,
      label = _props$label === void 0 ? true : _props$label,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'Select an option' : _props$placeholder,
      scope = props.scope,
      _props$smallSelect = props.smallSelect,
      smallSelect = _props$smallSelect === void 0 ? false : _props$smallSelect,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$selectedValues = props.selectedValues,
      selectedValues = _props$selectedValues === void 0 ? [] : _props$selectedValues,
      _props$setSelectedVal = props.setSelectedValues,
      setSelectedValues = _props$setSelectedVal === void 0 ? function () {} : _props$setSelectedVal,
      mode = props.mode,
      takeValue = props.takeValue;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOptionList = _useState2[0],
      setShowOptionList = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focusSearch = _useState4[0],
      setFocusSearch = _useState4[1];

  var selectRef = useRef();
  var value = fieldState.value,
      error = fieldState.error;
  var setValue = fieldApi.setValue,
      maskedValue = fieldApi.maskedValue;
  var name = field;
  useEffect(function () {
    return multiple && setValue(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.join(','));
  }, [selectedValues]);
  var classes = useStyle(defaultClasses, propClasses);

  var _useState5 = useState(options),
      _useState6 = _slicedToArray(_useState5, 2),
      filteredResults = _useState6[0],
      setFilteredResults = _useState6[1];

  useOutsideAlerter(selectRef, setShowOptionList, name, showOptionList, setFocusSearch, setFilteredResults, options);
  useEffect(function () {
    return setFilteredResults(options);
  }, [options]);

  var handleListDisplay = function handleListDisplay(e) {
    if (disabled || e.target.tagName === 'INPUT' && name === showOptionList) return;
    setShowOptionList(name === showOptionList ? false : name);
  };

  useEffect(function () {
    return startValue && !value && setValue(startValue);
  }, [startValue]);

  var handleOptionClick = function handleOptionClick(e, option) {
    setShowOptionList(false);
    onClick(takeValue ? option[takeValue] : option);
    setValue(takeValue ? option[takeValue] : option);
  };

  var filterResults = function filterResults(e) {
    return !e.target.value ? setFilteredResults(options) : setFilteredResults(_toConsumableArray(options.filter(function (option) {
      var _option$label, _option$label$toLower, _e$target$value;

      return option === null || option === void 0 ? void 0 : (_option$label = option.label) === null || _option$label === void 0 ? void 0 : (_option$label$toLower = _option$label.toLowerCase()) === null || _option$label$toLower === void 0 ? void 0 : _option$label$toLower.includes((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.toLowerCase());
    })));
  };

  return React.createElement("div", {
    className: "".concat(classes['custom-select-container'], " ").concat(smallSelect ? classes.smallSelect : ''),
    ref: selectRef
  }, React.createElement(SelectInput, {
    showOptionList: showOptionList,
    name: name,
    isSearchable: isSearchable,
    isPageSize: isPageSize,
    disabled: disabled,
    filterResults: filterResults,
    handleListDisplay: handleListDisplay,
    id: id,
    error: error,
    classes: classes,
    value: value || maskedValue,
    label: label,
    placeholder: placeholder,
    multiple: multiple,
    options: options,
    mode: mode,
    isTwoDimensional: isTwoDimensional,
    setFocusSearch: setFocusSearch,
    focusSearch: focusSearch
  }), React.createElement(List, {
    showOptionList: showOptionList,
    name: name,
    filteredResults: filteredResults,
    handleOptionClick: handleOptionClick,
    value: value,
    classes: classes,
    defaultMessage: defaultMessage,
    required: required,
    error: error,
    field: field,
    multiple: multiple,
    selectedValues: selectedValues,
    setSelectedValues: setSelectedValues
  }));
});
export default CustomSelect;